import { arrowDownToLineIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Download = createIcon({
  displayName: 'Download',
  paths: [
    'M723.2 489.131l-181.035 181.035c-16.683 16.683-43.648 16.683-60.331 0l-181.035-181.035c-16.64-16.64-16.64-43.648 0-60.331 16.683-16.64 43.691-16.64 60.331 0l108.203 108.203v-323.669c0-23.552 19.115-42.667 42.667-42.667s42.667 19.115 42.667 42.667v323.669l108.203-108.203c16.64-16.64 43.648-16.64 60.331 0 16.64 16.683 16.64 43.691 0 60.331zM853.333 640c0-23.552 19.115-42.667 42.667-42.667s42.667 19.115 42.667 42.667v170.667c0 23.552-19.115 42.667-42.667 42.667h-768c-23.552 0-42.667-19.115-42.667-42.667v-170.667c0-23.552 19.115-42.667 42.667-42.667s42.667 19.115 42.667 42.667v128h682.667v-128z'
  ],
  canvasPaths: canvasIconPaths(arrowDownToLineIcon)
})
